<ui-notification [uuid]="uuid()" [duration]="duration()" color="error">
  <ng-icon name="heroXCircle" size="24" class="!block size-6" slot="icon" />

  <p class="text-sm font-medium">
    {{ title() }}
  </p>
  @if (subtitle()) {
    <p class="mt-1 text-sm">
      {{ subtitle() }}
    </p>
  }
</ui-notification>
